import React, {
    useState,
    useEffect,
    Children,
} from 'react';

import ChevronIcon from '../svg/chevron';
import { useMediaQuery } from '../hook/useMediaQuery';

export default function Details({ className, summaryText, media = 768, children}) {
  const [isOpen, setIsOpen] = useState(false);
  const isMobile = useMediaQuery(`(max-width: ${media}px)`);

  return (
    isMobile ? 
      <details onToggle={(e) => setIsOpen(e.target.open)} className={`details details--${className}`}>
          <summary>{isOpen ? 'Hide' : 'Show'} {summaryText} <ChevronIcon /></summary>
          <>{children}</>
      </details>
      : <>
        {children}
      </>
   );
}